import { useEffect, useRef, useState } from 'react';
import { Label } from '../atoms/label';
import { SenyuubiTable } from './senyuubiTable';
import Const from '../../const/Const';
import { HomeFlTable } from './homeFlTable';

export const SenyuubiTableContainer = (props) => {
    const {
        popupFlg,
        popupRef,
        shokaKenriNenList,
        onClickOpenDescriptionHomeFlWindow
    } = props;

    const [mode, setMode] = useState(Const.SENYUBI_MODE);
    const [shokaKenriList, setShokaKenriList] = useState([]);
    const [shokaHomeFlList, setShokaHomeFlList] = useState([]);
    const [dispYear, setDispYear] = useState("");
    const [buttonKbn, setButtonKbn] = useState("");

    // ポップアップ表示時
    useEffect(() => {
        if (popupFlg) {
            setShokaKenriList(shokaKenriNenList?.[1]?.shokaKenriList);
            setDispYear(shokaKenriNenList?.[1]?.nenji);
            setButtonKbn("current");
        }
    }, [popupFlg]);

    // 消化権利リストからホームFLのデータを抽出
    useEffect(() => {
        if (shokaKenriNenList) {
            let shokaList = [];
            const list = shokaKenriNenList.filter(x => x.shokaHomeFlKenriList && 0 < x.shokaHomeFlKenriList.length);
            if (list && 0 < list.length) {
                shokaList = list.reduce((acc, value) => {
                    acc.push(...value.shokaHomeFlKenriList);
                    return acc;
                }, []);
            }
            setShokaHomeFlList(shokaList);
        }
    }, [shokaKenriNenList]);

    /**
     * 前年、当年ボタンのクリックイベント処理です。
     */
    const onClickPrev = () => {
        popupRef.current.scrollTop = 0;
        if (buttonKbn == "current") {
            setShokaKenriList(shokaKenriNenList?.[0].shokaKenriList);
            setDispYear(shokaKenriNenList?.[0].nenji);
            setButtonKbn("prev");
        } else if (buttonKbn == "next") {
            setShokaKenriList(shokaKenriNenList?.[1].shokaKenriList);
            setDispYear(shokaKenriNenList?.[1].nenji);
            setButtonKbn("current");
        }
    };

    /**
     * 翌年、当年ボタンのクリックイベント処理です。
     */
    const onClickNext = () => {
        popupRef.current.scrollTop = 0;
        if (buttonKbn == "current") {
            setShokaKenriList(shokaKenriNenList?.[2].shokaKenriList);
            setDispYear(shokaKenriNenList?.[2].nenji);
            setButtonKbn("next");
        } else if (buttonKbn == "prev") {
            setShokaKenriList(shokaKenriNenList?.[1].shokaKenriList);
            setDispYear(shokaKenriNenList?.[1].nenji);
            setButtonKbn("current");
        }
    };

    /**
     * 占有日ボタンのクリックイベント処理です。
     */
    const onClickSenyuubi = () => {
        setMode(Const.SENYUBI_MODE);
    };

    /**
     * ホームFLボタンのクリックイベント処理です。
     */
    const onClickHomeFl = () => {
        setMode(Const.HOME_FL_MODE);
        setShokaKenriList(shokaKenriNenList?.[1].shokaKenriList);
        setDispYear(shokaKenriNenList?.[1].nenji);
        setButtonKbn("current");
    };

    return (
        <>
            <div className="crawlSenyuubi_buttonArea">
                <div className="crawlSenyuubi_buttonAreaSenyuubi">
                    <button className="crawlSenyuubi_buttonSenyuubi" style={mode == Const.SENYUBI_MODE ? null : styles.isPassive} onClick={() => {onClickSenyuubi()}}>占有日</button>
                </div>
                <div className="crawlSenyuubi_buttonAreaHomeFl">
                    <button className={0 < shokaHomeFlList.length ? 'crawlSenyuubi_buttonHomeFl' : "hiddenItem"} style={mode == Const.HOME_FL_MODE ? null : styles.isPassive} onClick={() => {onClickHomeFl()}}>ホームフローティング</button>
                </div>
            </div>
            <Label
                label={`${mode == Const.SENYUBI_MODE ? dispYear : shokaKenriNenList?.[1].nenji}年`}
                className={'dispYearLabel'}
            />
            {
                mode === Const.SENYUBI_MODE ? // モード => 占有日
                    <>
                        <SenyuubiTable shokaKenriList={shokaKenriList} />
                        <div className='crawlSenyuubi_buttonArea'>
                            <div className='crawlSenyuubi_buttonAreaPrev'>
                                <button className={buttonKbn != "prev" ? 'crawlSenyuubi_buttonPrev' : "hiddenItem"} onClick={() => onClickPrev()}>{buttonKbn == "current" ? "＜　前年" : buttonKbn == "next" ? "＜　当年" : ""}</button>
                            </div>
                            <div className='crawlSenyuubi_buttonAreaNext'>
                                <button className={buttonKbn != "next" ? 'crawlSenyuubi_buttonNext' : "hiddenItem"} onClick={() => onClickNext()}>{buttonKbn == "current" ? "翌年　＞" : buttonKbn == "prev" ? "当年　＞" : ""}</button>
                            </div>
                        </div>
                    </>
                : mode === Const.HOME_FL_MODE ? // モード => ホームFL
                    <>
                        <HomeFlTable shokaHomeFlList={shokaHomeFlList} />
                        <div className="crawlSenyuubi_descHomeFl">ホームフローティングについては<a onClick={() => onClickOpenDescriptionHomeFlWindow()} style={styles.underline}>こちら</a></div>
                        <div class="crawlSenyuubi_descHomeFl"><Label label="※ホームフローティングは繰越利用できません" /></div>
                        <div class="crawlSenyuubi_descHomeFl"><Label label="※ホームフローティングは当年の今月・来月分のみ表示されます" /></div>
                    </>
                : null
            }
        </>
    )
}

const styles = {
    isPassive: {
        color: "#7b7b7b",
        backgroundColor: "#d3d3d3",
        border: "none"
    },
    underline: {
        paddingBottom: "0px",
        whiteSpace: "pre-line",
        color: "inherit",
        textDecoration: "none",
        borderBottom: "1px solid #000",
        cursor: "pointer",
    },
}